import React, { useState, useEffect } from "react";
import { FaYoutube, FaWhatsapp, FaArrowUp } from "react-icons/fa";

const Footer = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);

  const openYouTube = () => {
    window.open("https://www.youtube.com/channel/UCTb1n1pEJtlFZQd6x1QJaxw", "_blank");
  };

  const openWhatsApp = () => {
    window.open("https://wa.me/+919328273754?text=Jay%20Gurudev", "_blank");
  };

  // Show button after scrolling 300px
  useEffect(() => {
    const handleScroll = () => {
      setShowTopBtn(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* Back to Top Button */}
      {showTopBtn && (
        <div className="back-to-top" onClick={scrollToTop}>
          <FaArrowUp />
        </div>
      )}

      <footer className="footer">
        <div className="footer-icons">
          <FaYoutube className="footer-icon youtube" onClick={openYouTube} />
          <FaWhatsapp className="footer-icon whatsapp" onClick={openWhatsApp} />
        </div>

        <p className="footer-text">
          © {new Date().getFullYear()} Param Pujya Shree Devaji Gurudev. All rights reserved.
        </p>
      </footer>
    </>
  );
};

export default Footer;